module.exports = __webpack_public_path__ + "img/yiqiandao.a7ba47f7.png";